import { gql } from '@apollo/client';

export const VALIDATE_ZIPCODES_EXIST = gql`
  query ValidateZipcodesExist($zipcodes: [String!]!) {
    validateZipcodesExist(zipcodes: $zipcodes)
  }
`;

export interface ValidateZipcodesExistResponse {
  validateZipcodesExist: string[];
}

export interface ValidateZipcodesExistVariables {
  zipcodes: string[];
} 